// extracted by mini-css-extract-plugin
export default {"inner":"ControlSheetsSkeleton_inner_Sgj59"};